import type { CatalogResponse } from 'services/generated/commerce-service/models/CatalogResponse';
import type { Variant } from 'services/generated/commerce-service/models/Variant';

/**
 * @description Checks only the memberships in the catalog to see if any of them have a discount.
 * As of writing this all site wide promotions apply only to memberships.
 */
export const getDiscountKeyFromCatalog = (catalog: CatalogResponse) => {
  const discountId = catalog.memberships.find((membership) =>
    membership.variants.find(
      (variant) => variant.price?.discounted?.discount.key,
    ),
  )?.variants[0].price?.discounted?.discount.key;

  return discountId;
};

/**
 * This returns the absolute discounted amount for a given product in cents
 */
export const getAbsoluteDiscountAmount = (product: Variant) => {
  if (!product.price?.discounted) return null;
  return (
    product.price.value.cent_amount - product.price.discounted.value.cent_amount
  );
};

/**
 * This returns the absolute discounted amount for a given product
 */
export const getPermyriadDisplayValue = (product: Variant) => {
  if (!product.price?.discounted?.discount.permyriad) return null;
  return product.price.discounted.discount.permyriad / 100;
};
